/**
 * @copyright Copyright 2019 The MathWorks, Inc.
 */

define([
    "dojo/_base/declare",
    "mw-form/PushButton",
], function (declare, PushButton) {

    return declare(PushButton, {

        target: null,
        icon: "mwActionMenuIcon",
        text: "",
        description: "Options",
        baseClass: "mwWidget mwPushButton mwContextMenuButton",

        constructor: function(args) {
            args = args || {};
            this.set("target", args.target || null);
        },

        buildRendering: function() {
            this.inherited(arguments);
            this.domNode.classList.add("mwContextMenuButton");
        },

        postCreate: function() {
            this.inherited(arguments);
            this.own(
                this.on("click", this._handleLeftClick.bind(this)),
                this.on("contextmenu", this._handleRightClick.bind(this))
            );
        },

        /**
         * Set the domNode that this button emits "contextmenu" events on behalf of
         */
        _setTargetAttr: function(targetNode) {
            if (targetNode && !(targetNode instanceof EventTarget)) {
                throw new Error("'target' property expects an EventTarget!");
            }
            this._set("target", targetNode);
        },

        _handleLeftClick: function(event) {
            this._dispatchContextMenuEvent(event, this.domNode);
        },

        _handleRightClick: function(event) {
            // Only handle the event if it is not already a custom event
            if (!event.mwEventData) {
                event.preventDefault();
                event.stopPropagation();
                this._dispatchContextMenuEvent(event);
            }
        },

        /**
         * Utility function to dispatch a "contextmenu" event with supplementary information
         */
        _dispatchContextMenuEvent: function(event, aroundNode) {
            // Create "contextmenu" event with supplementary information
            var cmEvent = new MouseEvent("contextmenu", event);
            cmEvent.mwEventData = {};
            if (aroundNode) {
                cmEvent.mwEventData.around = aroundNode;
            }

            // Emit event from proper target, defaulting to this widget's parent if none exists
            var targetNode = this.target || this.domNode.parentElement;
            targetNode.dispatchEvent(cmEvent);
        }
    });
});
